import { Box, Flex, Heading, HStack, Image, Menu, MenuItem, MenuList, useColorModeValue as mode, Skeleton, SkeletonCircle, useMenuButton } from "@chakra-ui/react";
import React, { createContext, useContext } from "react";
import { BiLogOut, BiUserCircle, HiSelector } from "react-icons/all";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useAuth } from "../plugins/CookieAuthPlugin";
import { toAbsoluteUrl } from "../utils/helper";

const SidebarContext = createContext("SidebarContext");
export default function NavBar({ collapse }) {
  const { user, logout } = useAuth();
  const history = useHistory();

  return (
    <SidebarContext.Provider value={{ user, logout, collapse }}>
      <Box w="full" boxShadow="sm">
        <Flex zIndex="overlay" p="2" mx="auto" w={{ base: "full", sm: "95%", md: "85%", lg: "75%" }} transition="width 0.1s" align="center" justify="space-between">
          <HStack spacing="5" cursor="pointer" onClick={() => history.push("/")}>
            <Box h={{ base: "1.5em", sm: "1.8em", md: "2em" }} w="auto">
              <Image h="full" src={toAbsoluteUrl("/assets/logo.png")} />
            </Box>
            <Heading hidden={collapse} fontWeight="semibold" fontSize={{ base: "18px", md: "22px" }} color="brand.500">
              My S-Liquor
            </Heading>
          </HStack>

          {user && user.data && user.data[0] && <UserProfile />}
        </Flex>
      </Box>
    </SidebarContext.Provider>
  );
}

const UserProfile = () => {
  const { collapse, logout } = useContext(SidebarContext);

  return (
    <HStack spacing="4" px="2" flexShrink={0} p="4">
      <Menu>
        <AccountSwitcherButton collapse={collapse} />
        <MenuList shadow="lg" py="2" color={mode("gray.600", "gray.300")} px="2">
          <MenuItem rounded="md" _hover={{ bg: mode("gray.200", "gray.600") }} color="red" onClick={() => logout()} lefticon={<BiLogOut />}>
            Logout
          </MenuItem>
        </MenuList>
      </Menu>
    </HStack>
  );
};

const AccountSwitcherButton = () => {
  const { collapse, user } = useContext(SidebarContext);
  const buttonProps = useMenuButton();

  return (
    <Flex as="button" {...buttonProps} w="full" display="flex" justifyContent="center" alignItems="center" rounded="lg" p="2" fontSize="md" cursor="pointer" outline="0" transition="all 0.2s" _active={{ outline: "none" }} _focus={{ shadow: "outline", boxShadow: "none" }}>
      <HStack flex="1" spacing="3">
        <>
          {user.data[0] ? (
            <>
              {!collapse && (
                <Box textAlign="start">
                  <Box isTruncated fontWeight="semibold">
                    {(user.data[0].firstName || "") + " " + (user.data[0].lastName || "")}
                  </Box>
                </Box>
              )}
              <Image h="8" w="8" borderRadius="md" objectFit="cover" src={user.data[0].photo} fallback={<BiUserCircle size="1.8rem" />} alt="" />
            </>
          ) : (
            <>
              {!collapse && <Skeleton w="5rem" h="1rem"></Skeleton>}
              <SkeletonCircle size="7" />
            </>
          )}
        </>
      </HStack>
      {!collapse && (
        <Box fontSize="lg" color={mode("gray.800", "gray.400")}>
          <HiSelector />
        </Box>
      )}
    </Flex>
  );
};
